
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deployPipelines",
      resolverType: "mutation",
      routePath: "/deployPipelines",
      httpMethod: "POST",
    });
  